/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback, useRef } from 'react'
import clsx from 'clsx';
import customStyles from "../../../../../assets/styles/customStyles";
import { useDispatch, useSelector } from "react-redux";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import actions from "../../redux/actions";
import crudActions from "../../../../CRUD/redux/actions";
import { PincodeTable } from "./PincodeTable";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg"
import { Row, Col, Image, Space } from "antd";
import Down from "../../../../Shared/components/Icons/Down";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import { Button, TextField, Box, Autocomplete } from "@mui/material";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import MainHeader from "../../../../Shared/components/Header";
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import ImportIcon from "../../../../../assets/images/icon_actions/Import.svg";
import { toast } from 'react-toastify';
import usePrevious from "../../../../Shared/components/Previous";
import { NavLink } from "react-router-dom";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import { customPhoneValidation, emptyValidation } from "../../../../../helpers/validation";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import { ImportExport } from '../../../../Shared/components/ImportExport';
import { checkCRUDPermission, checkComponentPermission } from '../../../../../helpers/utilities';
import ClearIcon from "../../../../../assets/images/icon_actions/Clear Icon.svg";

const Pincode = (props) => {
    const { cityDetails, areaDetails, countryDetails, stateDetails, pincodeDetails, pincodeLoader } = useSelector(state => state.addressReducer);
    const { createDetails, createError, createLoader, editDetails, editError, getList, getData } = useSelector(state => state.crudReducer);
    const [visible, setVisible] = useState(false);
    const [pincodeName, setPincodeName] = useState('');
    const [cityId, setCityId] = useState('');
    const [search, setSearch] = useState('');
    const [iconAnimation, setIconAnimation] = useState(false);
    const [stateId, setStateId] = useState('');
    const [countryId, setCountryId] = useState('');
    const [cityData, setCityData] = useState([]);
    // const [cityFieldData, setCityFieldData] = useState([]);
    // const [stateFieldChange, setStateFieldChange] = useState(false);
    const prevSearch = usePrevious(search);
    const timeoutRef = useRef(null);

    const [errorPincodeName, setErrorPincodeName] = useState(false);

    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");
    const [skip, setSkip] = useState(0);
    const limit = 25;
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const prevEditDetails = usePrevious(editDetails);
    //const prevEditError = usePrevious(editError);
    const [errorCityId, setErrorCityId] = useState(false);
    const [errorStateId, setErrorStateId] = useState(false);
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const type = 'import';
    const [importVisible, setImportVisible] = useState(false);
    const [filterCityId, setFilterCityId] = useState('');
    const [filterStateId, setFilterStateId] = useState('');
    const { roleManagement } = useSelector(state => state.authReducer);
    const { moduleType } = props;
    const searchInput = useRef(null);

    const handleOpenImport = () => {
        setImportVisible(true);
    }

    const onExport = () => {
        loadImportExportData('Pincode');
    }

    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {
        let filter = { ["and"]: [] };

        if (search !== '') {
            filter['and'].push({ code: { like: '%' + search.trim() + '%' } });
        }

        if (filterCityId) {
            filter['and'].push({ cityId: filterCityId });
        }

        if (filterStateId) {
            filter['and'].push({ stateId: filterStateId });
        }

        dispatch({
            type: actions.PINCODE_DETAILS_START,
            export: name,
            data: data,
            selected: selected,
            extension: extension,
            url: 'pincode',
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
            }
        });
    }

    const handleImportClose = () => {
        setImportVisible(false);
    }


    const handleOpen = () => {
        setVisible(true);
        emptyState();
        emptyStateInput();
    };

    const emptyState = () => {
        setErrorPincodeName(false);
        setErrorCityId(false);
        setErrorStateId(false);
    }

    const emptyStateInput = () => {
        setPincodeName('');
        setCityId('');
        setStateId('');
        setCountryId('');
        setCityData([]);
    }

    const handleClose = () => {
        setVisible(false);
        emptyState();
        emptyStateInput();
    };

    const dispatch = useDispatch();

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(filterCityId, filterStateId, sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(filterCityId, filterStateId, sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);

    useEffect(() => {
        if (roleManagement !== '') {
            //  if (checkViewPermission('Pincode', history, 'Younote Admin')) {
            loadTasks();
            //  }
        }
        return () => {
            dispatch({
                type: actions.CLEAR_ADDRESS_DETAILS_START,
            });
        };
    }, [roleManagement]);

    useEffect(() => {
        setCityData(cityDetails);
    }, [cityDetails]);

    const prevGetData = usePrevious(getData);
    useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData?.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const dispatchFilter = (cityId, stateId, sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }

        let filter = { ["and"]: [] };

        if (search !== '') {
            filter['and'].push({ code: { like: '%' + search.trim() + '%' } });
        }

        if (cityId !== '') {
            filter['and'].push({ cityId: cityId });
        }

        if (stateId !== '') {
            filter['and'].push({ stateId: stateId });
        }

        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'pincode',
            skip: skip,
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip,
            }
        });
    }

    const loadTasks = useCallback(() => {
        dispatch({
            type: actions.COUNTRY_DETAILS_START, url: 'country', filter: {
                order: 'id desc'
            }
        });
        dispatch({
            type: actions.STATE_DETAILS_START, url: 'state', filter: {
                order: 'id desc'
            }
        });

        dispatchFilter(filterCityId, filterStateId, sortBy, sortOrder);
    });

    const createPincode = (e) => {
        e.preventDefault();
        let emptyPincodeName = customPhoneValidation('Pincode', pincodeName, 6);
        let emptyStateId = emptyValidation('State', stateId, 'dropDown');
        let emptyCityId = emptyValidation('City', cityId, 'dropDown');
        emptyState();
        if (emptyPincodeName.isValid && emptyCityId.isValid && emptyStateId.isValid) {
            dispatch({
                type: crudActions.CREATE_DETAILS_START,
                url: 'pincode',
                title: "Pincode",
                details: {
                    code: pincodeName,
                    cityId: cityId,
                    stateId: stateId,
                    countryId: countryId
                }
            });
        } else {
            if (emptyPincodeName?.errors) {
                setErrorPincodeName(emptyPincodeName.errors);
            }
            if (emptyCityId?.errors) {
                setErrorCityId(emptyCityId.errors);
            }
            if (emptyStateId?.errors) {
                setErrorStateId(emptyStateId.errors);
            }
        }
    }

    const handleChangeCity = (value) => {
        setFilterCityId(value);
        let a = [];
        if (value !== '') {
            a = cityDetails && cityDetails.length > 0 ? cityDetails.filter((el) => { return el.id === value }) : [];
            if (a && a.length > 0) {
                setFilterStateId(a[0]?.stateId);
            }
        }
        dispatchFilter(value, a[0]?.stateId ? a[0]?.stateId : filterStateId, sortBy, sortOrder);
    }

    const handleChangeState = (value) => {
        setFilterStateId(value);
        // setStateFieldChange(false);
        if (value !== '') {
            dispatch({
                type: actions.CITY_DETAILS_START, url: 'city', filter: {
                    where: { ["and"]: [{ stateId: value }] }
                }
            });
        } else {
            setCityData([]);
        }
        setFilterCityId('');
        dispatchFilter('', value, sortBy, sortOrder);
    }

    const changeCity = (value) => {
        setCityId(value);
        let a = cityDetails.filter(function (el) { return el.id === value });
        if (a && a?.length !== 0) {
            setStateId(a[0].stateId);
            setCountryId(a[0].countryId);
        }
    }

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            dispatchFilter(filterCityId, filterStateId, sortBy, sortOrder);
            setVisible(false);
            toast.dismiss();
            toast(createDetails);
            emptyStateInput();
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let error = createError.error.message;
            setErrorPincodeName(error);
        }
    }, [createDetails, createError]);


    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            setCityData([]);
        }
    }, [editDetails, editError]);

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(filterCityId, filterStateId, sortBy, sortOrder);
    }

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(filterCityId, filterStateId, sortBy, sortOrder, s);
    }

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const handleChange = (e) => {
        if (e.target.value === '') {
            handleChangeCity('')
        }
    }

    const handleStateChange = (e) => {
        if (e.target.value === '') {
            handleChangeState('')
        }
    }

    const handleStateChangeField = (id) => {
        setStateId(id);
        setCityId('');
        // setStateFieldChange(true);
        if (id !== '') {
            dispatch({
                type: actions.CITY_DETAILS_START, url: 'city', filter: {
                    where: { ["and"]: [{ stateId: id }] }
                }
            });
        } else {
            //setCityFieldData([]);
        }
    }


    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader {...props} img={SettingsImg}
                title={moduleType !== undefined ? moduleType : 'Younote Admin'}
                links={[{ 'label': moduleType !== undefined ? moduleType : 'Younote Admin', 'link': moduleType === 'Admin' ? '/admin' : '/younote-admin' },
                { 'label': 'Address Management', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'Pincode'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('Pincode', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search'
                                                type='search'
                                                value={search}
                                                className={classes.comInput}
                                                required
                                                variant={'standard'}
                                                onChange={(e) => setSearch(e.target.value)}
                                                // onChange={(e) => setPassword(e.target.value)}
                                                fullWidth
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                            {
                                                search && <NavLink to="#" onClick={() => setSearch('')} className={classes.searchClear}>
                                                    <Image
                                                        src={ClearIcon}
                                                        preview={false}
                                                    />
                                                </NavLink>
                                            }
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={clsx(classes.textAlignRight, classes.removeUnderline, classes.vertiCalScrollOverFlowParent)}>
                                    <div className={classes.vertiCalScrollOverFlow}>
                                        <Space size={[20, 20]} direction="horizontal" align="center">
                                            <Autocomplete
                                                className={clsx(classes.customAutocomplete, classes.customAutocompleteBorder, classes.width200)}
                                                popupIcon={<Down />}
                                                fullWidth
                                                forcePopupIcon={"auto"}
                                                clearOnEscape
                                                onClose={() => {
                                                    searchInput?.current?.blur();
                                                }}
                                                disableClearable
                                                getOptionLabel={(option) => option.name ? option.name : ""}
                                                options={stateDetails ? stateDetails : []}
                                                classes={{ paper: classes.dropdownStyle }}
                                                value={stateDetails && customObject(stateDetails, filterStateId, 'state') ? customObject(stateDetails, filterStateId, 'state') : []}
                                                onChange={(event, newValue) => {
                                                    if (typeof newValue === 'object' && newValue !== null) {
                                                        handleChangeState(newValue.id) // help to set the value
                                                    } else {
                                                        handleChangeState('') // help to reset the value
                                                    }
                                                }}
                                                renderInput={(params) => (
                                                    <TextField autoComplete='one-time-code'
                                                        inputRef={searchInput}
                                                        onChange={(e) => handleStateChange(e)}
                                                        {...params}
                                                        label='All State'
                                                        variant="standard"
                                                    />
                                                )}
                                            />
                                            {
                                                filterStateId !== '' && <Autocomplete
                                                    className={clsx(classes.customAutocomplete, classes.customAutocompleteBorder, classes.width200)}
                                                    popupIcon={<Down />}
                                                    fullWidth
                                                    forcePopupIcon={"auto"}
                                                    clearOnEscape
                                                    onClose={() => {
                                                        searchInput?.current?.blur();
                                                    }}
                                                    disableClearable
                                                    getOptionLabel={(option) => option.name ? option.name : ""}
                                                    options={cityData ? cityData : []}
                                                    classes={{ paper: classes.dropdownStyle }}
                                                    value={cityData && customObject(cityData, filterCityId, 'city') ? customObject(cityData, filterCityId, 'city') : []}
                                                    onChange={(event, newValue) => {
                                                        if (typeof newValue === 'object' && newValue !== null) {
                                                            handleChangeCity(newValue.id) // help to set the value
                                                        } else {
                                                            handleChangeCity('') // help to reset the value
                                                        }
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField autoComplete='one-time-code'
                                                            inputRef={searchInput}
                                                            onChange={(e) => handleChange(e)}
                                                            {...params}
                                                            label='All City'
                                                            variant="standard"
                                                        />
                                                    )}
                                                />
                                            }


                                            {
                                                roleManagement !== '' && checkComponentPermission('Pincode', 'Action', 'Export') &&
                                                <NavLink
                                                    to="#"
                                                    onClick={() => onExport()}
                                                    className={clsx(classes.customLink)}
                                                >
                                                    <Image
                                                        src={ExportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Pincode', 'Action', 'Import') &&
                                                <NavLink
                                                    to="#"
                                                    onClick={() => handleOpenImport()}
                                                    className={clsx(classes.customLink)}
                                                >
                                                    <Image
                                                        src={ImportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Import</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && (checkCRUDPermission('Pincode', 'create', 'Younote Admin') || checkCRUDPermission('Pincode', 'create', 'Admin')) &&
                                                <NavLink
                                                    to="#"
                                                    onClick={() => handleOpen()}
                                                    className={clsx(classes.customLink, classes.disInline, classes.cursor)}
                                                >
                                                    <Image
                                                        src={AddIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Add</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Pincode', 'Action', 'Filter') &&
                                                <></>
                                            }
                                        </Space>
                                    </div>
                                </Col>
                            </Row>
                            <PincodeTable
                                loadTasks={() => dispatchFilter(filterCityId, filterStateId, sortBy, sortOrder)}
                                cityDetails={cityData}
                                moduleType={moduleType}
                                countryDetails={countryDetails}
                                stateDetails={stateDetails}
                                areaDetails={areaDetails}
                                pincodeDetails={getList}
                                loadMore={loadMore}
                                handleStateChangeField={(id) => handleStateChangeField(id)}
                                loadMoreContent={loadMoreContent}
                                loadMoreTask={() => loadMoreTask()}
                                sortOrder={sortOrder} sortBy={sortBy}
                                customObject={(details, id) => customObject(details, id)}
                                roleManagement={roleManagement}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)} />
                        </>
                    }
                />
                <PrimaryDrawer
                    anchor={'right'}
                    open={visible}
                    variant={'temporary'}
                    handleClose={() => handleClose()}
                    title={'Add Pincode'}
                    width={"360px"}
                    className={clsx(classes.closeBackGround, classes.width100P)}
                    component={
                        <Box
                            className={clsx(classes.customForm, classes.removeUnderline)}
                            component="form"
                            autoComplete="off"
                            onSubmit={(e) => createPincode(e)}
                        >
                            <div className={classes.customFormFlex}>
                                <TextField autoComplete='one-time-code'
                                    label={["Pincode ", <span key={"Pincode"} className={classes.colorRedRequired}> *</span>]}
                                    variant={'standard'}
                                    error={errorPincodeName ? true : false}
                                    helperText={errorPincodeName}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}
                                    onChange={(e) => setPincodeName(e.target.value)}
                                />
                                <AutoCompleteComponent
                                    name={["State", <span key={"State"} className={classes.colorRedRequired}> *</span>]}
                                    heads={[{ 'key': 'name', 'name': 'State Name' },
                                    { 'key': 'country', 'name': 'Country Name', 'relation': 'name' }]}
                                    details={stateDetails}
                                    parentValue={customObject(stateDetails, stateId)}
                                    onChange={(data) => handleStateChangeField(data.id)}
                                    position={'bottom'}
                                    customClasses={classes.margin20t}
                                    parentError={errorStateId}
                                />
                                <AutoCompleteComponent
                                    name={["Dist/City/Town ", <span key={"Dist/City/Town"} className={classes.colorRedRequired}> *</span>]}
                                    heads={[{ 'key': 'name', 'name': 'Name' },
                                    { 'key': 'state', 'name': 'State Name', 'relation': 'shortName' }]}
                                    details={cityData ? cityData : []}
                                    parentValue={customObject(cityData, cityId)}
                                    onChange={(data) => changeCity(data.id)}
                                    position={'bottom'}
                                    customClasses={classes.margin20t}
                                    parentError={errorCityId}
                                />

                                <AutoCompleteComponent
                                    name={["Country"]}
                                    heads={[{ 'key': 'name', 'name': 'Country Name' }]}
                                    details={countryDetails}
                                    parentValue={customObject(countryDetails, countryId)}
                                    onChange={(data) => setCountryId(data.id)}
                                    position={'bottom'}
                                    customClasses={classes.margin20t}
                                />
                            </div>
                            <div className={clsx(classes.btnParent)}>
                                <Button
                                    key="add"
                                    type='submit'
                                    color='primary'
                                    variant="contained"
                                    className={clsx(classes.modalBtn, { [classes.loading]: createLoader })}>
                                    Save
                                </Button>
                            </div>
                        </Box>
                    }
                />
                <ImportExport
                    handleClose={() => handleImportClose()}
                    visible={importVisible}
                    title={'Pincode'}
                    type={type}
                    details={pincodeDetails}
                    loader={pincodeLoader}
                    loadImportExportData={(name, type, selected, extension) => loadImportExportData(name, type, selected, extension)}
                    loadTasks={() => { dispatchFilter(filterCityId, filterStateId, sortBy, sortOrder) }}
                />
            </div>
        </React.Fragment>
    )
}

export default Pincode